import LoGIn from './login'; // 登录
export default {
  LoGIn,
}